import { BaseCellOptionProps, CellProps } from '../types/Cell';
import { DefaultCell } from './DefaultCell';

export const VoucherCell = (props: CellProps): React.ReactElement => {
  const { label } = props as BaseCellOptionProps;

  return (
    <DefaultCell
      px={10}
      py={5}
      bgColor="tag.background.green"
      textColor="text.secondary"
      label={label}
      labelWeight="500"
      borderRadius="5px"
    />
  );
};

export const UserDashboardVoucherCell = (options: CellProps): React.ReactElement => {
  const { label } = options as BaseCellOptionProps;

  return <DefaultCell px={10} py={20} label={label} textColor="text.secondary" labelWeight="500" />;
};
